export enum DiagnosticoPages {
  empresas = "empresas",
  detalhes = "detalhes"
}
